var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"currentColor","fillRule":"nonzero"},React.createElement("g",null,React.createElement("path",{"d":"M13.468 0H3.544C1.587 0 0 1.587 0 3.544v9.924c0 1.957 1.587 3.544 3.544 3.544h9.924c1.958 0 3.544-1.587 3.544-3.544V3.544C17.012 1.587 15.426 0 13.468 0zM5.67 13.468H3.544V5.67h2.127v7.797zM4.607 4.772c-.684 0-1.24-.56-1.24-1.25s.556-1.25 1.24-1.25c.685 0 1.24.56 1.24 1.25s-.554 1.25-1.24 1.25zm9.57 8.696H12.05V9.495c0-2.387-2.835-2.206-2.835 0v3.973H7.088V5.67h2.127v1.25c.99-1.832 4.962-1.968 4.962 1.756v4.79z","transform":"translate(-1038 -2491) translate(1038 2491)"})))));
}

Linkedin.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
